import type { InvoiceOverview } from '@vy/api-definition';
import React from 'react';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import { SyncInvoicesTable } from './sync-invoices-dialog-components/SyncInvoicesTable';

type SyncInvoicesDialogProps = {
  open: boolean;
  onClose: () => void;
  invoices: InvoiceOverview[];
  onSyncInvoices: () => void;
};

export const SyncInvoicesDialog: React.FC<SyncInvoicesDialogProps> = ({
  open,
  onClose,
  invoices,
  onSyncInvoices,
}) => {
  const handleSubmitSync = () => {
    onSyncInvoices();
    onClose();
  };

  return (
    <VyDialog
      open={open}
      onClose={onClose}
      fullWidth
      slotProps={{
        paper: {
          className: 'max-w-[750px] overflow-visible',
        },
      }}
      label={`Sync ${invoices.length} Invoices With ERP`}
      labelDescription="Sync 'Approved' invoices with your ERP."
      warningText="Invoices which are still in 'Draft' or 'In review' workflow cannot be synced just yet."
      cancelButtonText="Cancel"
      ctaText="Sync"
      onSubmit={handleSubmitSync}
    >
      <SyncInvoicesTable items={invoices ?? []} itemsCount={invoices.length} />
    </VyDialog>
  );
};
